import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=c0aa787e"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0aa787e')) {
      api.createRecord('c0aa787e', component.options)
    } else {
      api.reload('c0aa787e', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=c0aa787e", function () {
      api.rerender('c0aa787e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/accounts/view/layout/Index.vue"
export default component.exports